import skygear from 'skygear';

const Email = skygear.Record.extend('email');

export default function createEmail(name, email, subject, content) {
  const mailFormat = /^\w+([\.-]?\w+)@\w+([\.-]?\w+)(\.\w{2,3})+$/;
  if (name && email && subject && content && email.match(mailFormat)) {
    window.gtag('event', 'conversion', { send_to: 'AW-823717499/CTOwCNSf_cwYEPvc44gD' });
  }
  const record = new Email({
    name, email, subject, content,
  });
  return skygear.publicDB.save(record);
}



// WEBPACK FOOTER //
// ./src/models/Email.js